import MarketDepthGeneric from "@frameworks/web/components/generic/ScripDetailPane/MarketDepth/MarketdepthGeneric";
import PivotPoints from "@frameworks/web/components/generic/pivotPoints";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
const TocMarketDepth = (props) => {
    var _a, _b, _c, _d, _e;
    const [pivotPoint, setPivotPoint] = useState([]);
    const { data: scripDetail } = useSelector((state) => state.scripDetail);
    const marketDepthColumn = [
        {
            columnName: "Qty",
            key: "bidQuantity",
        },
        {
            columnName: "Orders",
            key: "bidOrder",
        },
        {
            columnName: "Bids",
            key: "bidPrice",
        },
        {
            columnName: "Ask",
            key: "askPrice",
        },
        {
            columnName: "Orders",
            key: "askOrder",
        },
        {
            columnName: "Qty",
            key: "askQuantity",
        },
    ];
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10;
        if (((_b = (_a = props === null || props === void 0 ? void 0 : props.scriptData) === null || _a === void 0 ? void 0 : _a.quote) === null || _b === void 0 ? void 0 : _b.quoteObj) || ((_c = scripDetail === null || scripDetail === void 0 ? void 0 : scripDetail.quote) === null || _c === void 0 ? void 0 : _c.quoteObj)) {
            setPivotPoint([
                {
                    pivotName: "Open",
                    pivotValue: ((_f = (_e = (_d = props === null || props === void 0 ? void 0 : props.scriptData) === null || _d === void 0 ? void 0 : _d.quote) === null || _e === void 0 ? void 0 : _e.quoteObj) === null || _f === void 0 ? void 0 : _f.open)
                        ? (_j = (_h = (_g = props === null || props === void 0 ? void 0 : props.scriptData) === null || _g === void 0 ? void 0 : _g.quote) === null || _h === void 0 ? void 0 : _h.quoteObj) === null || _j === void 0 ? void 0 : _j.open
                        : (_l = (_k = scripDetail === null || scripDetail === void 0 ? void 0 : scripDetail.quote) === null || _k === void 0 ? void 0 : _k.quoteObj) === null || _l === void 0 ? void 0 : _l.open,
                },
                {
                    pivotName: "Low",
                    pivotValue: ((_p = (_o = (_m = props === null || props === void 0 ? void 0 : props.scriptData) === null || _m === void 0 ? void 0 : _m.quote) === null || _o === void 0 ? void 0 : _o.quoteObj) === null || _p === void 0 ? void 0 : _p.low)
                        ? (_s = (_r = (_q = props === null || props === void 0 ? void 0 : props.scriptData) === null || _q === void 0 ? void 0 : _q.quote) === null || _r === void 0 ? void 0 : _r.quoteObj) === null || _s === void 0 ? void 0 : _s.low
                        : (_u = (_t = scripDetail === null || scripDetail === void 0 ? void 0 : scripDetail.quote) === null || _t === void 0 ? void 0 : _t.quoteObj) === null || _u === void 0 ? void 0 : _u.low,
                },
                {
                    pivotName: "High",
                    pivotValue: ((_x = (_w = (_v = props === null || props === void 0 ? void 0 : props.scriptData) === null || _v === void 0 ? void 0 : _v.quote) === null || _w === void 0 ? void 0 : _w.quoteObj) === null || _x === void 0 ? void 0 : _x.high)
                        ? (_0 = (_z = (_y = props === null || props === void 0 ? void 0 : props.scriptData) === null || _y === void 0 ? void 0 : _y.quote) === null || _z === void 0 ? void 0 : _z.quoteObj) === null || _0 === void 0 ? void 0 : _0.high
                        : (_2 = (_1 = scripDetail === null || scripDetail === void 0 ? void 0 : scripDetail.quote) === null || _1 === void 0 ? void 0 : _1.quoteObj) === null || _2 === void 0 ? void 0 : _2.high,
                },
                {
                    pivotName: "Prev Close",
                    pivotValue: ((_5 = (_4 = (_3 = props === null || props === void 0 ? void 0 : props.scriptData) === null || _3 === void 0 ? void 0 : _3.quote) === null || _4 === void 0 ? void 0 : _4.quoteObj) === null || _5 === void 0 ? void 0 : _5.close)
                        ? (_8 = (_7 = (_6 = props === null || props === void 0 ? void 0 : props.scriptData) === null || _6 === void 0 ? void 0 : _6.quote) === null || _7 === void 0 ? void 0 : _7.quoteObj) === null || _8 === void 0 ? void 0 : _8.close
                        : (_10 = (_9 = scripDetail === null || scripDetail === void 0 ? void 0 : scripDetail.quote) === null || _9 === void 0 ? void 0 : _9.quoteObj) === null || _10 === void 0 ? void 0 : _10.close,
                },
            ]);
        }
    }, [props === null || props === void 0 ? void 0 : props.scriptData, scripDetail]);
    return (React.createElement(Row, null,
        React.createElement(Col, { lg: 12 },
            React.createElement(PivotPoints, { pointPoints: pivotPoint })),
        React.createElement(Col, { lg: 12 },
            React.createElement(MarketDepthGeneric, { marketDepth: ((_b = (_a = props === null || props === void 0 ? void 0 : props.scriptData) === null || _a === void 0 ? void 0 : _a.quote) === null || _b === void 0 ? void 0 : _b.marketDepth)
                    ? (_d = (_c = props === null || props === void 0 ? void 0 : props.scriptData) === null || _c === void 0 ? void 0 : _c.quote) === null || _d === void 0 ? void 0 : _d.marketDepth
                    : (_e = scripDetail === null || scripDetail === void 0 ? void 0 : scripDetail.quote) === null || _e === void 0 ? void 0 : _e.marketDepth, showtitle: true, columns: marketDepthColumn, parentClass: "common-marketdepth pt-0" }))));
};
export default TocMarketDepth;
